import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SingleOption } from '../../../model/singleOption';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuestionComponent),
      multi: true,
    },
  ],
})
export class QuestionComponent implements ControlValueAccessor {
  @Input() description: string;
  @Input() options: SingleOption[];
  @Input() invalidAnswer: boolean;

  value: string;
  disabled: boolean;
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(newValue: string): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onRatingChange(value: any) {
    this.onChange(value);
    this.onTouched();
  }
}
